export default "__VITE_ASSET__CZ6BKF82__";